/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {ChangeEvent, useState} from 'react';
import {makeStyles} from '@material-ui/core';
import Dropdown from '../components/menus/Dropdown';

// defines the prop definitions for types option ...
interface TypeOption {
  label: string;
  value: string;
  disabled?: boolean;
};

// defines the prop definitions fro types chooser ...
interface ReportDropdownTypeChooserProps {
  onChange?: Function;
  fieldLabel?: string;
  defaultValue?: TypeOption['value'];
  readOnly?: boolean;
  required?: boolean;
  hasError?: boolean;
  options?: any;
  style?: any;
};

// defines the styles used by types chooser ...
const useStyles = makeStyles(theme => ({
  root : {
    padding : '0px !important',
    margin  : '0px !important',
    width   : '20%'
  }
}));

/**
 * Generates the types options list ...
 */
function getTypesOptions(types): TypeOption[] {
  return types?.map(({label, value}) => {
    return {label, value};
  });
};

/**
 * Allows user to choose a preferred types from one of the available/supported
 * types.
 *
 * ```typescript
 * import {ReportDropdownChooser} from '@ion/dls/src/editors/ReportDropdownChooser';
 *
 * <ReportDropdownChooser options={options}
 *   fieldLabel={translate('common:types.fieldLabel')}
 *   defaultValue='default'
 *   hasError={true}
 *   readOnly={false}
 *   onChange={handleChange} />
 *
 * ```
 */
export const ReportDropdownChooser = ({
  onChange,
  defaultValue,
  hasError,
  fieldLabel,
  options = [],
  required = false,
  readOnly = false,
  style = {}
}: ReportDropdownTypeChooserProps) => {
  const classes                   = useStyles();
  const [selected, setSelected]   = useState<string>(defaultValue);
  const optionList: TypeOption[]  = getTypesOptions(options);

  function handleChange({target: {value}}: ChangeEvent<HTMLSelectElement>) {
    setSelected(value);
    onChange?.(value);
  };

  return (
    <div className={classes.root} style={style}>
      <Dropdown required={required}
        options={optionList}
        disabled={readOnly}
        fieldLabel={fieldLabel}
        hasError={hasError}
        value={selected}
        onChange={handleChange} />
    </div>
  );
};

export default ReportDropdownChooser;
